import {
    MONTH_END_INVENTORY_LOADING,
    MONTH_END_INVENTORY_SUCCESS

} from '../actions/MonthEndInventoryAction';

const initialState = {
    monthEndInventoryData: null,
    isLoading: true,
};

const MonthEndInventoryReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case MONTH_END_INVENTORY_SUCCESS:
            return { ...state, monthEndInventoryData: action.data, isLoading: false };

        case MONTH_END_INVENTORY_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default MonthEndInventoryReducer;
